import { render, staticRenderFns } from "./CreateEditForm.vue?vue&type=template&id=01ae5243&scoped=true"
import script from "./CreateEditForm.vue?vue&type=script&lang=js"
export * from "./CreateEditForm.vue?vue&type=script&lang=js"
import style0 from "./CreateEditForm.vue?vue&type=style&index=0&id=01ae5243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae5243",
  null
  
)

export default component.exports